export default "__VITE_ASSET__6558a20b__"